/* ribogrow: shared cart helpers – pack selector (product page), free gift (cart), 1er -> 3er upgrade hint (cart), guarantee dialog */
(function () {
  'use strict';
  if (window.rgCart) return;
  var base = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';

  /* Add items via /cart/add.js and refresh + open the Eurus cart drawer (fallback: cart page). */
  function addItems(items, opts) {
    opts = opts || {};
    items = (items || []).filter(function (x) { return x && x.id; });
    if (!items.length) return Promise.reject(new Error('no items'));
    var A = window.Alpine, H = A && A.store && A.store('xCartHelper'), M = A && A.store && A.store('xMiniCart');
    if (H && M && window.rgCartType !== 'page') {
      return H.withCartLock(function (ev) {
        return fetch(base + 'cart/add.js', {
          method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items: items, sections: H.getSectionsToRender().map(function (x) { return x.id; }), sections_url: window.location.pathname })
        })
          .then(function (r) { return H.cartJson(r); })
          .then(function (res) {
            if (!res || res.status) { throw new Error((res && (res.description || res.message)) || 'add failed'); }
            H.reRenderSections(res.sections);
            var bubble = document.getElementById('cart-icon-bubble');
            if (bubble) H.currentItemCount = parseInt(bubble.innerHTML);
            document.dispatchEvent(new CustomEvent('eurus:cart:items-changed'));
            document.dispatchEvent(new CustomEvent('eurus:product:added', { detail: { product: res.items } }));
            if (opts.open !== false) M.openCart();
            return H.settleWithCart(ev);
          });
      }, { type: 'shopify:cart:lines-update', action: 'add', context: 'cart', lines: items.map(function (x) { return { merchandiseId: x.id, quantity: x.quantity || 1 }; }) });
    }
    return fetch(base + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ items: items }) })
      .then(function (r) { if (!r.ok) throw new Error('add failed'); window.location.href = base + 'cart'; });
  }

  /* ---------- pack selector ---------- */
  function selectorOf(el) {
    var sec = el.closest('[id^="shopify-section-"]') || document;
    return sec.querySelector('[data-rgp]');
  }
  function selected(rgp) {
    var opt = rgp.querySelector('.rgp__opt.is-selected') || rgp.querySelector('.rgp__radio:checked') && rgp.querySelector('.rgp__radio:checked').closest('.rgp__opt');
    return opt;
  }
  function sync(rgp) {
    var opt = selected(rgp);
    var custom = !!(opt && !opt.hasAttribute('data-current'));
    var sec = rgp.closest('[id^="shopify-section-"]') || document.body;
    sec.classList.toggle('rgp-custom', custom);
  }
  document.addEventListener('change', function (e) {
    var r = e.target.closest && e.target.closest('.rgp__radio');
    if (!r) return;
    var rgp = r.closest('[data-rgp]');
    rgp.querySelectorAll('.rgp__opt').forEach(function (o) { o.classList.toggle('is-selected', o.contains(r) && r.checked); });
    var msg = rgp.querySelector('[data-rgp-msg]'); if (msg) msg.textContent = '';
    sync(rgp);
  });
  document.querySelectorAll('[data-rgp]').forEach(sync);

  /* intercept the main add-to-cart button when another pack than the page's product is selected */
  function handleAtc(e) {
    var btn = e.target.closest && e.target.closest('form[data-type="add-to-cart-form"] button[type="submit"], form[data-type="add-to-cart-form"] [name="add"]');
    if (!btn) return;
    var form = btn.closest('form');
    if (!form || /sticky/.test(form.id || '')) return;
    var rgp = selectorOf(btn);
    if (!rgp) return;
    var opt = selected(rgp);
    if (!opt || opt.hasAttribute('data-current')) return; /* Eurus handles its own product */
    e.preventDefault(); e.stopImmediatePropagation();
    if (btn.dataset.rgBusy) return;
    var items; try { items = JSON.parse(opt.getAttribute('data-items')); } catch (err) { return; }
    btn.dataset.rgBusy = '1'; btn.setAttribute('aria-busy', 'true'); btn.classList.add('opacity-70');
    addItems(items).then(function () {
      delete btn.dataset.rgBusy; btn.removeAttribute('aria-busy'); btn.classList.remove('opacity-70');
    }, function () {
      delete btn.dataset.rgBusy; btn.removeAttribute('aria-busy'); btn.classList.remove('opacity-70');
      var msg = rgp.querySelector('[data-rgp-msg]');
      if (msg) msg.textContent = rgp.getAttribute('data-error') || tx('error', 'Das hat leider nicht geklappt. Bitte versuchen Sie es erneut.');
    });
  }
  document.addEventListener('click', handleAtc, true);
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form.matches || !form.matches('form[data-type="add-to-cart-form"]') || /sticky/.test(form.id || '')) return;
    var rgp = selectorOf(form); if (!rgp) return;
    var opt = selected(rgp);
    if (opt && !opt.hasAttribute('data-current')) { e.preventDefault(); e.stopImmediatePropagation(); }
  }, true);

  /* ---------- free gift button in cart ---------- */
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-rg-gift-add]');
    if (!b) return;
    e.preventDefault();
    if (b.disabled) return;
    b.disabled = true;
    ss(SK_OPT, false); giftFailed = false;
    addItems([{ id: Number(b.getAttribute('data-rg-gift-add')), quantity: 1 }], { open: true }).catch(function () { b.disabled = false; });
  });

  /* ---------- 1er -> 3er Pack upgrade button in cart ---------- */
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-rg-up]');
    if (!b) return;
    e.preventDefault();
    if (b.disabled) return;
    var key = b.getAttribute('data-rg-up'), it = null;
    ((lastCart && lastCart.items) || []).forEach(function (x) { if (x.key === key) it = x; });
    if (!it) return;
    b.disabled = true;
    var use = Math.min(it.quantity, 3);
    writeCart([{ id: key, quantity: it.quantity - use }], [{ id: Number(b.getAttribute('data-to')), quantity: 1 }])
      .then(function () { document.dispatchEvent(new CustomEvent('eurus:cart:items-changed')); refreshGift(); },
        function () {
          b.disabled = false;
          var p = b.parentNode && b.parentNode.querySelector('.rg-up__text');
          if (p) p.textContent = tx('error', 'Das hat leider nicht geklappt. Bitte versuchen Sie es erneut.');
          refreshGift();
        });
  });

  /* ---------- guarantee dialog ---------- */
  document.addEventListener('click', function (e) {
    var o = e.target.closest && e.target.closest('[data-rgg-open]');
    if (o) {
      var d = document.getElementById('rgg-modal');
      if (d && typeof d.showModal === 'function') { e.preventDefault(); d.showModal(); }
      return;
    }
    var c = e.target.closest && e.target.closest('[data-rgg-close]');
    if (c) { var dd = c.closest('dialog'); if (dd) dd.close(); return; }
    if (e.target.tagName === 'DIALOG' && e.target.id === 'rgg-modal') e.target.close();
  });

  /* ---------- texts (rgConfig.t = section "ribogrow Einstellungen" in the header group, translatable) ---------- */
  function tx(k, d) { var t = window.rgConfig && rgConfig.t; return (t && t[k]) || d; }
  function esc(s) { return String(s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;'); }
  /* "Geschafft: …" -> bold lead-in up to the first colon (only when it is short) */
  function boldLead(s) { var i = s.indexOf(':'); return i > 0 && i < 30 ? '<strong>' + s.slice(0, i + 1) + '</strong>' + s.slice(i + 1) : s; }

  /* ---------- money ---------- */
  function money(cents) {
    var sample = (window.rgConfig && rgConfig.moneySample) || '1.234,56 €';
    var v = (cents / 100).toFixed(2), parts = v.split('.');
    if (sample.indexOf('1.234,56') > -1) return sample.replace('1.234,56', parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.') + ',' + parts[1]);
    if (sample.indexOf('1,234.56') > -1) return sample.replace('1,234.56', parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',') + '.' + parts[1]);
    return v.replace('.', ',') + ' €';
  }

  /* ---------- "= X € / Monat" on product cards ---------- */
  function perMonthCards(root) {
    var pm = window.rgConfig && rgConfig.perMonth;
    if (!pm) return;
    (root || document).querySelectorAll('.x-card-price').forEach(function (pc) {
      if (pc.querySelector('.rg-per-month') || pc.closest('template')) return;
      var el = pc, link = null;
      for (var i = 0; i < 10 && el && !link; i++) { el = el.parentElement; if (el) link = el.querySelector('a[href*="/products/"]'); }
      if (!link) return;
      var m = link.getAttribute('href').match(/\/products\/([^/?#]+)/);
      if (!m || !pm[m[1]]) return;
      var span = document.createElement('span');
      span.className = 'rg-per-month rg-per-month--card';
      span.textContent = '= ' + tx('per_month', '[€] / Monat').replace('[€]', pm[m[1]]);
      pc.appendChild(span);
    });
  }

  /* ---------- cart writes (gift + upgrade) ----------
     Line changes via /cart/change.js (by line key), then adds via /cart/add.js, inside the Eurus cart lock;
     the cart sections are re-rendered from the last response. */
  function writeCart(changes, adds) {
    var A = window.Alpine, H = A && A.store && A.store('xCartHelper');
    var secs = [];
    try { secs = H ? H.getSectionsToRender().map(function (x) { return x.id; }) : []; } catch (e) { secs = []; }
    function post(path, body) {
      if (secs.length) { body.sections = secs; body.sections_url = window.location.pathname; }
      return fetch(base + path, { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify(body) })
        .then(function (r) {
          return r.json().then(function (j) {
            if (!r.ok || (j && j.status && j.status !== 200)) throw new Error((j && (j.description || j.message)) || 'cart write failed');
            return j;
          });
        });
    }
    function run() {
      var p = Promise.resolve(null);
      (changes || []).forEach(function (c) { p = p.then(function () { return post('cart/change.js', { id: c.id, quantity: c.quantity }); }); });
      if (adds && adds.length) p = p.then(function () { return post('cart/add.js', { items: adds }); });
      return p.then(function (res) {
        if (H && res && res.sections) {
          H.reRenderSections(res.sections);
          var bubble = document.getElementById('cart-icon-bubble');
          if (bubble) H.currentItemCount = parseInt(bubble.innerHTML) || H.currentItemCount;
        } else if (!H && /\/cart\/?$/.test(window.location.pathname)) {
          window.location.reload();
        }
        return res;
      });
    }
    return H && H.withCartLock ? H.withCartLock(function () { return run(); }) : run();
  }

  /* ---------- free gift (rgConfig.gift: own 0 € product, added automatically) ----------
     Value = regular prices of all cart items except the gift and the paid version of the gift (discount codes
     are entered at checkout and do not change it). From the threshold the gift is added once – a paid brush in
     the cart is swapped for it –, below the threshold it is removed again (a swapped brush comes back).
     A customer who removes the gift keeps it removed ("Gratis hinzufügen" button instead) until the value
     drops below the threshold. */
  var SK_OPT = 'rgGiftOptOut', SK_SWAP = 'rgGiftSwap';
  function ss(k, v) {
    try {
      if (v === undefined) return window.sessionStorage.getItem(k);
      if (v) window.sessionStorage.setItem(k, '1'); else window.sessionStorage.removeItem(k);
    } catch (e) { return null; }
    return null;
  }
  var lastCart = null, giftBusy = false, giftSeen = null, giftFailed = false;
  function giftState(cart) {
    var g = rgConfig.gift, st = { qual: 0, gift: [], paid: [], qty: 0 };
    ((cart && cart.items) || []).forEach(function (it) {
      if (it.product_id === g.product) { st.gift.push(it); st.qty += it.quantity; }
      else if (g.paid && it.product_id === g.paid.product) st.paid.push(it);
      else st.qual += it.original_line_price;
    });
    st.reached = st.qual >= g.threshold;
    return st;
  }
  /* returns true when it started a cart write (the cart is refreshed afterwards) */
  function reconcileGift(cart) {
    var g = window.rgConfig && rgConfig.gift;
    if (!g || !cart || giftBusy) return false;
    var st = giftState(cart);
    if (!st.reached) ss(SK_OPT, false);
    else if (giftSeen && giftSeen.qty > 0 && st.qty === 0) ss(SK_OPT, true); /* removed by the customer */
    giftSeen = st;
    var changes = [], adds = [];
    if (st.reached && st.qty === 0 && !ss(SK_OPT) && !giftFailed) {
      if (st.paid.length) { changes.push({ id: st.paid[0].key, quantity: st.paid[0].quantity - 1 }); ss(SK_SWAP, true); }
      adds.push({ id: g.variant, quantity: 1 });
    } else if (st.reached && st.qty > 1) {
      st.gift.forEach(function (it, i) { changes.push({ id: it.key, quantity: i === 0 ? 1 : 0 }); });
    } else if (!st.reached && st.qty > 0) {
      st.gift.forEach(function (it) { changes.push({ id: it.key, quantity: 0 }); });
      if (ss(SK_SWAP) && g.paid) adds.push({ id: g.paid.variant, quantity: 1 });
      ss(SK_SWAP, false);
    }
    if (!changes.length && !adds.length) return false;
    giftBusy = true;
    writeCart(changes, adds)
      .catch(function () { if (adds.length) giftFailed = true; })
      .then(function () { giftBusy = false; giftSeen = null; refreshGift(); });
    return true;
  }
  function giftEl(cart) {
    var g = window.rgConfig && rgConfig.gift;
    if (!g || !cart || !cart.item_count) return null;
    var st = giftState(cart), has = st.qty > 0, hasPaid = st.paid.length > 0;
    var rest = g.threshold - st.qual, pct = Math.max(0, Math.min(100, Math.floor(st.qual * 100 / g.threshold)));
    if (st.qual <= 0 && !hasPaid) return null; /* only the gift itself (it is removed right away) */
    var txt;
    if (rest > 0) txt = (has || hasPaid) ? tx('cart_rest_has', 'Noch [€] – dann ist Ihre [G] gratis.') : tx('cart_rest', 'Noch [€] bis zu Ihrer gratis [G].');
    else txt = has ? tx('cart_done_has', 'Geschafft: Ihre [G] ist gratis.') : tx('cart_done', 'Geschafft: Sie erhalten eine [G] gratis dazu.');
    txt = boldLead(esc(txt)).replace('[€]', '<strong>' + esc(money(Math.max(rest, 0))) + '</strong>').replace('[G]', esc(g.name));
    var d = document.createElement('div');
    d.className = 'rg-gift' + (rest <= 0 ? ' is-reached' : '');
    d.setAttribute('data-rg-gift', '');
    d.innerHTML = '<div class="rg-gift__row"><span class="rg-gift__icon" aria-hidden="true"><svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="8" width="18" height="4" rx="1"/><path d="M12 8v13M19 12v8a1 1 0 0 1-1 1H6a1 1 0 0 1-1-1v-8M7.5 8a2.5 2.5 0 0 1 0-5C10 3 12 8 12 8s2-5 4.5-5a2.5 2.5 0 0 1 0 5"/></svg></span>'
      + '<p class="rg-gift__text">' + txt + '</p>'
      + (rest <= 0 && !has && !giftBusy ? '<button type="button" class="rg-gift__btn" data-rg-gift-add="' + g.variant + '">' + esc(tx('cart_add', 'Gratis hinzufügen')) + '</button>' : '')
      + '</div><div class="rg-gift__bar" aria-hidden="true"><span style="width:' + pct + '%"></span></div>';
    return d;
  }

  /* ---------- cart decorations (drawer + cart page), idempotent: safe to run after every re-render ---------- */
  function linesOf(key, idPrefix) {
    return Array.prototype.slice.call(document.querySelectorAll('[id="' + idPrefix + key.replace(/"/g, '') + '"]'));
  }
  function handleOf(a) {
    var m = (a.getAttribute('href') || '').match(/\/products\/([^/?#]+)/);
    return m ? decodeURIComponent(m[1]) : '';
  }
  /* gift line: no quantity selector, "Gratis" tag, links point to the regular brush */
  function markGiftLines(cart) {
    var g = window.rgConfig && rgConfig.gift;
    if (!g || !cart) return;
    var giftKeys = {};
    cart.items.forEach(function (it) { if (it.product_id === g.product) giftKeys[it.key] = 1; });
    document.querySelectorAll('.rg-gift-line').forEach(function (row) {
      var rb = row.querySelector('[id^="remove-"]');
      if (rb && giftKeys[rb.id.slice(7)]) return;
      row.classList.remove('rg-gift-line');
      var tag = row.querySelector('.rg-gift-badge'); if (tag) tag.remove();
    });
    cart.items.forEach(function (it) {
      if (it.product_id !== g.product) return;
      linesOf(it.key, 'remove-').forEach(function (btn) {
        var row = btn.closest('tr') || btn.closest('.cart-item');
        if (!row || row.classList.contains('rg-gift-line')) return;
        row.classList.add('rg-gift-line');
        var links = row.querySelectorAll('a[href*="/products/"]');
        Array.prototype.forEach.call(links, function (a) { if (g.paid && g.paid.url) a.setAttribute('href', g.paid.url); });
        var title = null;
        Array.prototype.forEach.call(links, function (a) { if (!title && a.textContent.trim()) title = a; });
        if (title && !row.querySelector('.rg-gift-badge')) {
          var tag = document.createElement('span');
          tag.className = 'rg-gift-badge';
          tag.textContent = tx('gift_tag', 'Gratis');
          title.parentNode.insertBefore(tag, title.nextSibling);
        }
      });
    });
  }
  /* "Dazu passend": never the 0 € gift; the paid brush only while the gift is not (yet) earned */
  function filterUpsell(cart) {
    var g = window.rgConfig && rgConfig.gift;
    if (!g) return;
    var st = cart ? giftState(cart) : null;
    var hidePaid = !!(g.paid && st && (st.qty > 0 || st.reached));
    document.querySelectorAll('#cart-upsell-drawer').forEach(function (list) {
      Array.prototype.slice.call(list.children).forEach(function (slide) {
        var a = slide.querySelector('a[href*="/products/"]');
        if (!a) return;
        var h = handleOf(a);
        if (h === g.handle || (hidePaid && g.paid && h === g.paid.handle)) slide.remove();
      });
      var wrap = list.closest('#mini-cart-upsell');
      if (!wrap) return;
      var any = list.querySelector('a[href*="/products/"]');
      wrap.classList.toggle('rg-upsell-empty', !any);
    });
  }
  /* 1er -> 3er Pack hint under the single-bottle lines (rgConfig.upgrade) */
  function upgradeBoxes(cart) {
    var U = (window.rgConfig && rgConfig.upgrade) || [];
    var want = {};
    if (cart && U.length) {
      cart.items.forEach(function (it) {
        U.forEach(function (u) {
          if (u.from === it.variant_id && u.fromPrice * 3 > u.toPrice) want[it.key] = { u: u, q: it.quantity };
        });
      });
    }
    document.querySelectorAll('.rg-up').forEach(function (box) { if (!want[box.getAttribute('data-key')]) box.remove(); });
    Object.keys(want).forEach(function (key) {
      var w = want[key];
      linesOf(key, 'LineItemError-').forEach(function (anchor) {
        var prev = anchor.previousElementSibling;
        if (prev && prev.classList.contains('rg-up') && prev.getAttribute('data-key') === key) return;
        var txt = esc(tx('up_text', 'Spar-Tipp: 3er-Pack für [€] statt [P]'))
          .replace('[€]', '<strong>' + esc(money(w.u.toPrice)) + '</strong>')
          .replace('[P]', esc(money(w.u.fromPrice * 3)));
        var box = document.createElement('div');
        box.className = 'rg-up';
        box.setAttribute('data-key', key);
        box.innerHTML = '<p class="rg-up__text">' + txt + '</p><button type="button" class="rg-up__btn" data-rg-up="' + esc(key) + '" data-to="' + w.u.to + '">' + esc(tx('up_btn', 'Zum 3er-Pack wechseln')) + '</button>';
        anchor.parentNode.insertBefore(box, anchor);
      });
    });
  }
  function decorate(cart) {
    cart = cart || lastCart;
    if (!cart) return;
    markGiftLines(cart);
    filterUpsell(cart);
    upgradeBoxes(cart);
  }

  function mountGift(cart) {
    if (cart) lastCart = cart;
    cart = lastCart;
    var spots = [];
    var dr = document.getElementById('x-cart-drawer-container') || document.getElementById('shopify-section-cart-drawer');
    var drItems = dr && dr.querySelector('.scrollbar-body');
    if (drItems) spots.push([drItems.parentNode, drItems, 'drawer']);
    var pageForm = document.querySelector('#main-cart-items form#cart');
    if (pageForm) spots.push([pageForm.parentNode, pageForm, 'page']);
    spots.forEach(function (sp) {
      var old = sp[0].querySelector(':scope > .rg-gift');
      var el = giftEl(cart);
      if (old) old.remove();
      if (el) { el.classList.add('rg-gift--' + sp[2]); sp[0].insertBefore(el, sp[1]); }
    });
    decorate(cart);
  }
  function refreshGift() {
    var c = window.rgConfig;
    if (!(c && (c.gift || (c.upgrade && c.upgrade.length)))) return;
    fetch(base + 'cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) { lastCart = cart; reconcileGift(cart); mountGift(cart); })
      .catch(function () {});
  }
  var giftTimer = null;
  function soon() { clearTimeout(giftTimer); giftTimer = setTimeout(refreshGift, 250); }
  ['eurus:cart:items-changed', 'eurus:product:added', 'cart:updated'].forEach(function (ev) { document.addEventListener(ev, soon); });

  /* ---------- cart display fixes (drawer + cart page) ----------
     1) Eurus prints cart totals with money_with_currency ("94,97 € EUR"); the store format stays unchanged,
        we only drop the duplicate currency code in the cart texts.
     2) Drawer: the coupon hint ("custom_additional_text") sits below the payment icons and is easily
        missed on mobile – move it above the checkout buttons. */
  function fixMoneyText(root) {
    if (!root || !document.createTreeWalker) return;
    var w = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, null), n, list = [];
    while ((n = w.nextNode())) { if (n.nodeValue.indexOf('EUR') > -1 && /€\s?EUR/.test(n.nodeValue)) list.push(n); }
    list.forEach(function (t) { t.nodeValue = t.nodeValue.replace(/€\s?EUR\b/g, '€'); });
  }
  function placeCoupon(dr) {
    if (!dr) return;
    var hint = dr.querySelector('.drawer-additional-text');
    var btn = dr.querySelector('#checkout-submit');
    if (!hint || !btn || !btn.parentElement) return;
    var row = btn.parentElement;
    if (!hint.classList.contains('rg-coupon')) hint.classList.add('rg-coupon');
    if (hint.nextElementSibling !== row && row.parentNode) row.parentNode.insertBefore(hint, row);
  }
  function fixCart(el) {
    if (!el) return;
    fixMoneyText(el);
    if (el.id === 'x-cart-drawer-container' || el.id === 'shopify-section-cart-drawer') placeCoupon(el);
  }
  function observe(el) {
    if (!el || !window.MutationObserver) return;
    fixCart(el);
    var queued = false;
    new MutationObserver(function () {
      if (queued) return;
      queued = true;
      (window.requestAnimationFrame ? function (f) { window.requestAnimationFrame(f); } : function (f) { setTimeout(f, 16); })(function () {
        queued = false;
        fixCart(el);
        if (!lastCart) return;
        var needs = (el.querySelector('.scrollbar-body, form#cart') && !el.querySelector('.rg-gift'));
        if (needs) mountGift(); else decorate();
      });
    }).observe(el, { childList: true, subtree: true, characterData: true });
  }

  function texts(root) { if (window.rgT) window.rgT(root || document); }
  document.addEventListener('shopify:section:load', function (e) { texts(e.target); });
  function init() {
    texts(document);
    perMonthCards();
    observe(document.getElementById('x-cart-drawer-container') || document.getElementById('shopify-section-cart-drawer'));
    observe(document.getElementById('main-cart-items'));
    refreshGift();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  window.addEventListener('load', function () { perMonthCards(); });
  window.addEventListener('pageshow', function (e) { if (e.persisted) refreshGift(); });

  window.rgCart = { addItems: addItems, refreshGift: refreshGift, perMonthCards: perMonthCards, fixCart: fixCart };
})();
